import { BaseView } from "./base-view";
import { Input, Output, EventEmitter, SimpleChanges, Directive } from "@angular/core";

@Directive()
export class BasePopup extends BaseView {
	@Input() popupdata: any;
	@Output()
	popupClose: EventEmitter<string> = new EventEmitter<string>();
	@Output()
	popupOpened: EventEmitter<string> = new EventEmitter<string>();

	public ngOnChanges(simplechanges: SimpleChanges) {
		this.initialize(this.popupdata);
	}

	public initialize(data: any) {}
	public popupClosed() {
		this.popupClose.emit("c");
	}
	public popupOpen() {
		this.popupOpened.emit("c");
	}
	public disposeMe(): void {}
}
